var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImportMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.3,3.7H3.7c-.8,0-1.4.6-1.4,1.4v21.9c0,.8.6,1.4,1.4,1.4h24.6c.8,0,1.4-.6,1.4-1.4V5c0-.8-.6-1.4-1.4-1.4ZM16,21.5c-2.3,0-4.1-1.8-4.1-4.1h-6.8V6.4h21.9v11h-6.8c0,2.3-1.8,4.1-4.1,4.1ZM21.5,11.9h-4.1v-4.1h-2.7v4.1h-4.1l5.5,6.2,5.5-6.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportMenu);
export default __webpack_public_path__ + "static/media/icon_import_menu.e6927799cf9c70fe888c8da6f8d8d5bb.svg";
export { ForwardRef as ReactComponent };